import PercentIcon from "assets/icons/PercentIcon";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";

export default function LatencyPenalty() {
  const data = useFormikContext<InstallmentData>();
  const { defCur } = useCurrency();
  const currency = data.values.currency?.en_title || defCur.en_title;
  const penaltyRate = data.values.penaltyRate;
  const penaltyRateType = data.values.penaltyRateType || "percent";
  return (
    <div className="flex items-center gap-8 flex-wrap">
      <div className="w-48">
        <BasicTextInput
          type="number-native"
          label="محاسبه جریمه پس از "
          style={{ padding: "0px 12px 0px 0px" }}
          val={data.values.penaltyGap}
          onChange={(val) => data.setFieldValue("penaltyGap", val)}
          prefix={
            <div className="w-24 my-2 border-r border-gray-200">
              <BasicSelect
                containerStyle={{ minWidth: 60 }}
                menuStyle={{ minWidth: 60 }}
                btnStyle={{ border: "none", minWidth: 60 }}
                defaultValue={data.values.penaltyGapType || "month"}
                onChange={(val) => data.setFieldValue("penaltyGapType", val)}
                options={[
                  { label: "روز", value: "day" },
                  { label: "ماه", value: "month" },
                  { label: "سال", value: "year" },
                ]}
              />
            </div>
          }
        />
      </div>
      <div>
        <BasicTextInput
          type={penaltyRateType === "percent" ? "number-native" : "price"}
          label="نرخ جریمه"
          style={{ padding: "0px 12px 0px 0px" }}
          val={penaltyRate}
          onChange={(val) => data.setFieldValue("penaltyRate", val)}
          prefix={
            <div className="w-24 my-2 border-r border-gray-200">
              <BasicSelect
                containerStyle={{ minWidth: 70 }}
                menuStyle={{ minWidth: 70 }}
                btnStyle={{ border: "none", minWidth: 70 }}
                defaultValue={penaltyRateType}
                onChange={(val) => {
                  data.setFieldValue("penaltyRate", 0);
                  data.setFieldValue("penaltyRateType", val);
                }}
                options={[
                  {
                    label: <PercentIcon style={{ transform: "scale(0.6)" }} color="#95A3B5" />,
                    value: "percent",
                  },
                  { label: <span className="text-[#95A3B5]">{currency}</span>, value: "currency" },
                ]}
              />
            </div>
          }
        />
      </div>
    </div>
  );
}
